import { IDateRange } from "@/components/date-picker/interface";
import { endOfDay } from "date-fns/fp";
import { useDateFormatPreference } from "@/hooks/use-date-format-preference";
import { formatDateFromDate } from "@/utils/date-format-config";

const useDatePicker = () => {
  const { preference } = useDateFormatPreference();

  const onSelectDateRange = (dateRange: IDateRange) => {
    if (dateRange.endDate) {
      dateRange.endDate = endOfDay(dateRange.endDate);
    }
  };

  const dateStringFormat = (inputDate: Date): string => {
    if (inputDate === null) {
      return "";
    }
    return formatDateFromDate(inputDate, preference);
  };

  return {
    dateStringFormat,
    onSelectDateRange,
  };
};

export { useDatePicker };
